export { default } from './PaymentThreeDomainSecure';
